/* eslint-disable react/jsx-no-target-blank */

import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { AddMenuItemModal } from '../../../partials/modals/add-menu-item/AddMenuItemModal';
import * as API from '../../../../app/api';
import { useOptionalApp } from '../../../../app/pages/devops/context/AppContext';
import { isSuperAdmin, getUserData, GetPermissions } from '../../../../app/modules/auth';
import { MenuSection } from './menu/MenuSection';
import { MenuGroupProvider } from './menu/MenuGroupContext';
import { useSidebar } from './menu/SidebarContext';
import { getMenuAccess } from './menu/menuAccess';
import { getAvailableBriefingTopics } from '../../../../app/pages/briefing-promotions/topics/data/topics';

export function AsideMenuMain() {
	const permissions = GetPermissions();
  const menuAccess = getMenuAccess(permissions, !!isSuperAdmin());
  const availableBriefingTopics = getAvailableBriefingTopics(permissions);
  const devOpsApp = useOptionalApp();
  const boards = devOpsApp?.state.boards || [];
  const { requestedOpenMenu } = useSidebar();

	function renderMenu(item: any) {
		if (!item) return null;

		if (item.section) {
			return <>
				<MenuSection label={item.section}>
					{item.children && item.children.map((x: any, i: number) => renderMenu(x))}
				</MenuSection>
			</>
		}

		const MenuElement = item.children && item.children.length > 0 ? AsideMenuItemWithSub : AsideMenuItem;

		if (item.label) {
			return <MenuElement key={item.id} to={item.to} title={item.label} fontIcon={item.fontIcon} icon={item.icon} hasBullet={item.hasBullet}>
				{item.children && item.children.map((x: any, i: number) => renderMenu(x))}
			</MenuElement>
		}
	}

	return (
    <MenuGroupProvider defaultOpenId={requestedOpenMenu}>
      <div className="flex flex-col pb-3 h-full">
        <div className="space-y-0.5">
          <AsideMenuItem
            to="/home"
            icon="/media/icons/duotune/menu/home.svg"
            title="Página Inicial"
            fontIcon="bi-app-indicator"
          />

          {menuAccess.unilever ? (
            <AsideMenuItemWithSub
              to="/cashback"
              icon="/media/icons/duotune/menu/unilever-white.svg"
              title="Unilever"
              fontIcon="bi-app-indicator"
            >
              {permissions?.some(feature => feature.name.includes('unilever-regionais-view')) ? (
                <AsideMenuItem
                  to="/ul-regionais"
                  icon="/media/icons/duotune/menu/icon-regional.svg"
                  title="Regionais UL"
                  fontIcon="bi-app-indicator"
                />
              ) : null}

              {permissions?.some(feature => feature.name.includes('unilever-tamanhos-view')) ? (
                <AsideMenuItem
                  to="/ul-tamanhos"
                  icon="/media/icons/duotune/menu/ruler.svg"
                  title="Tamanho de Lojas UL"
                  fontIcon="bi-app-indicator"
                />
              ) : null}

              {permissions?.some(feature => feature.name.includes('unilever-ids-ecoa-apuracao-view')) ? (
                <AsideMenuItem
                  to="/ul-ids-ecoa-apuracao"
                  icon="/media/icons/duotune/menu/menu-ids-ecoa.svg"
                  title="IDs E-COA - Apuração"
                  fontIcon="bi-app-indicator"
                />
              ) : null}

			  {permissions?.some(feature => feature.name.includes('unilever-metas-unilever')) ?
					<>
						<AsideMenuItem
							to='/ul-metas'
							icon='/media/icons/duotune/menu/datatransfer/metasUL.svg'
							title={'Metas UL'}
							fontIcon='bi-app-indicator' />
						{/*<AsideMenuItem
							to='/ul-metas-legado'
							icon='/media/icons/duotune/menu/datatransfer/metasUL.svg'
							title={'Metas UL (Legado)'}
							fontIcon='bi-app-indicator' /> */}
					</>
			  : null}

              {permissions?.some(feature => feature.name.includes('unilever-relatorios-ul-')) ? (
                <AsideMenuItemWithSub to="" icon="/media/icons/duotune/menu/reports/reports.svg" title="Relatórios UL" fontIcon="bi-app-indicator">
                  {permissions?.some(feature => feature.name.includes('unilever-relatorios-ul-cadastro-promo-view')) ? (
                    <AsideMenuItem to="/ul-relatorios/cadastro-promo" icon="/media/icons/duotune/menu/document-sheet.svg" title="Cadastro Promo UL" fontIcon="bi-app-indicator" />
                  ) : null}

                  {permissions?.some(feature => feature.name.includes('unilever-relatorios-ul-consumo-promo-view')) ? (
                    <AsideMenuItem to="/ul-relatorios/consumo-promo" icon="/media/icons/duotune/menu/reports/promocoes.svg" title="Consumo Promo UL" fontIcon="bi-app-indicator" />
                  ) : null}
                </AsideMenuItemWithSub>
              ) : null}
            </AsideMenuItemWithSub>
          ) : null}

					{menuAccess.cashback ?
						<AsideMenuItemWithSub to='/cashback' icon='/media/icons/duotune/menu/cashback.svg' title={'Cashback'} fontIcon='bi-app-indicator'>
							{permissions?.some(feature => feature.name.includes('cashback-lojas-participantes-view')) ?
								<AsideMenuItem to='/lojas' icon='/media/icons/duotune/menu/store.svg' title={'Lojas Participantes'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-listas-view')) ?
								<AsideMenuItem to='/listas' icon='/media/icons/duotune/menu/lists2.svg' title={'Listas'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-regionais-view')) ?
								<AsideMenuItem to='/regionais' icon='/media/icons/duotune/menu/icon-regional.svg' title={'Regionais'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-tamanhos-view')) ?
								<AsideMenuItem to='/tamanhos' icon='/media/icons/duotune/menu/ruler.svg' title={'Tamanho'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-bus-view')) ?
								<AsideMenuItem to='/bus' icon='/media/icons/duotune/menu/building.svg' title={'BU'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-tabela-valores-view')) ?
								<AsideMenuItem to='/precos' icon='/media/icons/duotune/menu/document-sheet.svg' title={'Tabela de Valores'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-cupons-view')) ?
								<AsideMenuItem to='/cupons' icon='/media/icons/duotune/menu/coupon2.svg' title={'Cupons'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-relatorios')) ?
								<AsideMenuItemWithSub to='/relatorios' icon='/media/icons/duotune/menu/document.svg' title={'Relatórios'} fontIcon='bi-app-indicator'>
									{permissions?.some(feature => feature.name.includes('cashback-relatorios-positivacao')) ?
										<AsideMenuItem to='/relatorios/positivacao' icon='/media/icons/duotune/menu/icon-positivacao.svg' title={'Positivação'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('cashback-relatorios-ativacao')) ?
										<AsideMenuItem to='/relatorios/ativacao' icon='/media/icons/duotune/menu/icon-ativacao.svg' title={'Ativação'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('cashback-relatorios-lojistas')) ?
										<AsideMenuItem to='/relatorios/lojistas' icon='/media/icons/duotune/menu/store.svg' title={'Lojistas'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('cashback-relatorios-cupons')) ?
										<AsideMenuItem to='/relatorios/cupons' icon='/media/icons/duotune/menu/coupon2.svg' title={'Cupons'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('cashback-relatorios-apuracao')) ?
										<AsideMenuItem to='/relatorios/apuracao' icon='/media/icons/duotune/menu/apuracao3.svg' title={'Apuração'} fontIcon='bi-app-indicator' /> : null}
								</AsideMenuItemWithSub> : null}
							{permissions?.some(feature => feature.name === 'cashback-alert-view') ?
								<AsideMenuItem to='/alerts' icon='/media/icons/duotune/menu/icon-alerts.svg' title={'Alertas'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('cashback-validacoes')) ?
								<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/assoc_promoid_cupomid.svg' title={'Validações'} fontIcon='bi-app-indicator'>
									{permissions?.some(feature => feature.name.includes('cashback-validacoes-ass-promoid-cupomdescid-view')) ?
										<AsideMenuItem to='/validacoes/promo_cupom' icon='/media/icons/duotune/menu/conecta/assoc_promoid_cupomid.svg' title={'Associação de PromoID a CupomDescID'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('cashback-validacoes-comp-benef-valorxvalor')) ?
										<AsideMenuItem to='/validacoes/comparacao_beneficio_valor' icon='/media/icons/duotune/menu/conecta/comp_benef_valor.svg' title={'Comparação Beneficio Valor x Valor Cupom Utilizado'} fontIcon='bi-app-indicator' /> : null}
								</AsideMenuItemWithSub> : null}

						</AsideMenuItemWithSub> : null}

					{menuAccess.conecta ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/conecta.svg' title={'Conecta'} fontIcon='bi-app-indicator'>
							{permissions?.some(feature => feature.name.includes('conecta-extracao-')) ?
								<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/extract.svg' title={'Extração'} fontIcon='bi-app-indicator'>

									{permissions?.some(feature => feature.name.includes('conecta-extracao-sellers-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/seller.svg' title={'Sellers'} fontIcon='bi-app-indicator'>
											{permissions?.some(feature => feature.name.includes('conecta-extracao-sellers-sellers-view')) ?
												<AsideMenuItem to='/conecta/extracao/seller' icon='/media/icons/duotune/menu/conecta/seller.svg' title={'Seller'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-sellers-seller-group-view')) ?
												<AsideMenuItem to='/conecta/extracao/seller-group' icon='/media/icons/duotune/menu/conecta/seller-group.svg' title={'Seller Group'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-sellers-seller-mapping-view')) ?
												<AsideMenuItem to='/conecta/extracao/seller-mapping' icon='/media/icons/duotune/menu/conecta/seller-mapping.svg' title={'Seller Mapping'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-sellers-blocklist-seller-view')) ?
												<AsideMenuItem to='/conecta/extracao/blocklist-seller' icon='/media/icons/duotune/menu/conecta/blocklist-seller.svg' title={'Blacklist Seller'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-pedidos-view')) ?
										<AsideMenuItem to='/conecta/extracao/pedidos' icon='/media/icons/duotune/menu/conecta/pedidos.svg' title={'Pedidos'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/lojista-customer.svg' title={'Lojista'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-customer-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-customer' icon='/media/icons/duotune/menu/conecta/lojista-customer.svg' title={'Customer'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-company-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-company' icon='/media/icons/duotune/menu/conecta/lojista-company.svg' title={'Company'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-ul-nao-ponderadas-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-ul-nao-ponderadas' icon='/media/icons/duotune/menu/conecta/ul-nao-ponderada.svg' title={'UL Não Ponderadas'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-ul-ponderadas-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-ul-ponderadas' icon='/media/icons/duotune/menu/conecta/ul-ponderada.svg' title={'UL Ponderadas'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-vip-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-vip' icon='/media/icons/duotune/menu/conecta/vip.svg' title={'VIP'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-grupo-lojista-root-view')) ?
												<AsideMenuItem to='/conecta/extracao/grupo-lojista-root' icon='/media/icons/duotune/menu/conecta/grupo-lojista-root.svg' title={'Grupo Lojista - Root'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-grupo-lojista-open-view')) ?
												<AsideMenuItem to='/conecta/extracao/grupo-lojista-open' icon='/media/icons/duotune/menu/conecta/grupo-lojista-open.svg' title={'Grupo Lojista - Open'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-customer-cnpj-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-customer-cnpj' icon='/media/icons/duotune/menu/conecta/conecta-extrato-lojista-customer-cnpj.svg' title={'Lojista Customer - CNPJ'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-lojista-company-cnpj-view')) ?
												<AsideMenuItem to='/conecta/extracao/lojista-company-cnpj' icon='/media/icons/duotune/menu/conecta/conecta-extrato-lojista-company-cnpj.svg' title={'Lojista Company - CNPJ'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-vendedor-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/vendedor.svg' title={'Vendedor'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-vendedor-vendedor-view')) ?
												<AsideMenuItem to='/conecta/extracao/vendedor' icon='/media/icons/duotune/menu/conecta/vendedor.svg' title={'Vendedor'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-vendedor-grupo-vendedor-view')) ?
												<AsideMenuItem to='/conecta/extracao/grupo-vendedor' icon='/media/icons/duotune/menu/conecta/grupo-vendedor.svg' title={'Grupo Vendedor'} fontIcon='bi-app-indicator' /> : null}
										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-limite-credito-view')) ?
										<AsideMenuItem to='/conecta/extracao/limite-credito' icon='/media/icons/duotune/menu/conecta/credit-limit.svg' title={'Limite de Crédito'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-vouchers-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/voucher-primario.svg' title={'Vouchers'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-vouchers-primario-view')) ?
												<AsideMenuItem to='/conecta/extracao/vouchers-primario' icon='/media/icons/duotune/menu/conecta/voucher-primario.svg' title={'Vouchers Primário'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-vouchers-secundario-view')) ?
												<AsideMenuItem to='/conecta/extracao/vouchers-secundario' icon='/media/icons/duotune/menu/conecta/voucher-secundario.svg' title={'Vouchers Secundário'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-produto-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/produto.svg' title={'Produto'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-produto-produto-view')) ?
												<AsideMenuItem to='/conecta/extracao/produto' icon='/media/icons/duotune/menu/conecta/produto.svg' title={'Produto'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-produto-marca-view')) ?
												<AsideMenuItem to='/conecta/extracao/marca' icon='/media/icons/duotune/menu/conecta/marca.svg' title={'Marca'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-produto-categoria-view')) ?
												<AsideMenuItem to='/conecta/extracao/categoria' icon='/media/icons/duotune/menu/conecta/categoria.svg' title={'Categoria'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-industrias-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/industria.svg' title={'Indústrias'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-industrias-industrias-view')) ?
												<AsideMenuItem to='/conecta/extracao/industria' icon='/media/icons/duotune/menu/conecta/industria.svg' title={'Indústria'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-industrias-blocklist-industria-view')) ?
												<AsideMenuItem to='/conecta/extracao/blocklist-industria' icon='/media/icons/duotune/menu/conecta/blocklist-industria.svg' title={'Blocklist Indústria'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-devit-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/devit.svg' title={'DevIT'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-devit-distribuidores-view')) ?
												<AsideMenuItem to='/conecta/extracao/devit-distribuidores' icon='/media/icons/duotune/menu/conecta/devit-distribuidores.svg' title={'Distribuidores'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-devit-vendedores-view')) ?
												<AsideMenuItem to='/conecta/extracao/devit-vendedores' icon='/media/icons/duotune/menu/conecta/devit-vendedores.svg' title={'Vendedores'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-devit-lojistas-view')) ?
												<AsideMenuItem to='/conecta/extracao/devit-lojistas' icon='/media/icons/duotune/menu/conecta/devit-lojistas.svg' title={'Lojistas'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-extracao-freshdesk-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/freshdesk.svg' title={'Freshdesk'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-extracao-freshdesk-lojista-company-view')) ?
												<AsideMenuItem to='/conecta/extracao/freshdesk-lojista-company' icon='/media/icons/duotune/menu/conecta/freshdesk-lojista-company.svg' title={'Lojista Company'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-freshdesk-lojista-contact-view')) ?
												<AsideMenuItem to='/conecta/extracao/freshdesk-lojista-contact' icon='/media/icons/duotune/menu/conecta/freshdesk-lojista-contact.svg' title={'Lojista Contact'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-freshdesk-vendedor-view')) ?
												<AsideMenuItem to='/conecta/extracao/freshdesk-vendedor' icon='/media/icons/duotune/menu/conecta/freshdesk-vendedor.svg' title={'Vendedor'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-extracao-freshdesk-distribuidor-view')) ?
												<AsideMenuItem to='/conecta/extracao/freshdesk-distribuidor' icon='/media/icons/duotune/menu/conecta/freshdesk-distribuidor.svg' title={'Distribuidor'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

								</AsideMenuItemWithSub> : null}

							{permissions?.some(feature => feature.name.includes('conecta-diferencas-')) ?
								<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/diferencas.svg' title={'Diferenças'} fontIcon='bi-app-indicator'>
									{permissions?.some(feature => feature.name.includes('conecta-diferencas-sellers')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/diferencas/sellers.svg' title={'Sellers'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-sellers-sellers-view')) ?
												<AsideMenuItem to='/conecta/diferencas/sellers' icon='/media/icons/duotune/menu/conecta/diferencas/sellers.svg' title={'Sellers'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-sellers-sellers-group-view')) ?
												<AsideMenuItem to='/conecta/diferencas/seller-group' icon='/media/icons/duotune/menu/conecta/diferencas/sellers-group.svg' title={'Seller Group'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-sellers-blocklist-seller-view')) ?
												<AsideMenuItem to='/conecta/diferencas/blocklist-seller' icon='/media/icons/duotune/menu/conecta/diferencas/blocklist-seller.svg' title={'BlackList Seller'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-diferencas-pedidos-view')) ?
										<AsideMenuItem to='/conecta/diferencas/pedidos' icon='/media/icons/duotune/menu/conecta/diferencas/pedidos.svg' title={'Pedidos'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-diferencas-lojista-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/diferencas/lojista.svg' title={'Lojista'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-lojista-customer-view')) ?
												<AsideMenuItem to='/conecta/diferencas/lojista-customer' icon='/media/icons/duotune/menu/conecta/diferencas/lojista-customer.svg' title={'Customer'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-lojista-company-view')) ?
												<AsideMenuItem to='/conecta/diferencas/lojista-company' icon='/media/icons/duotune/menu/conecta/diferencas/lojista-company.svg' title={'Company'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-diferencas-vendedores-vendedores-view')) ?
										<AsideMenuItem to='/conecta/diferencas/vendedores' icon='/media/icons/duotune/menu/conecta/diferencas/vendedores.svg' title={'Vendedores'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-diferencas-produto-')) ?
										<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/diferencas/produto.svg' title={'Produto'} fontIcon='bi-app-indicator'>

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-produto-produto-view')) ?
												<AsideMenuItem to='/conecta/diferencas/produto' icon='/media/icons/duotune/menu/conecta/diferencas/produto.svg' title={'Produto'} fontIcon='bi-app-indicator' /> : null}

											{permissions?.some(feature => feature.name.includes('conecta-diferencas-produto-marcas-view')) ?
												<AsideMenuItem to='/conecta/diferencas/marcas' icon='/media/icons/duotune/menu/conecta/diferencas/marcas.svg' title={'Marcas'} fontIcon='bi-app-indicator' /> : null}

										</AsideMenuItemWithSub> : null}

									{permissions?.some(feature => feature.name.includes('conecta-diferencas-industrias-industrias-view')) ?
										<AsideMenuItem to='/conecta/diferencas/industrias' icon='/media/icons/duotune/menu/conecta/diferencas/industrias.svg' title={'Indústrias'} fontIcon='bi-app-indicator' /> : null}

								</AsideMenuItemWithSub> : null}

							{permissions?.some(feature => feature.name.includes('conecta-validacao-')) ?
								<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/conecta/validacao/validacao.svg' title={'Validação'} fontIcon='bi-app-indicator'>

									{permissions?.some(feature => feature.name.includes('conecta-validacao-golive-view')) ?
										<AsideMenuItem to='/conecta/validacao/golive' icon='/media/icons/duotune/menu/conecta/validacao/golive.svg' title={'Go Live'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-validacao-estoque-view')) ?
										<AsideMenuItem to='/conecta/validacao/estoque' icon='/media/icons/duotune/menu/conecta/validacao/estoque.svg' title={'Estoque'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-validacao-email-view')) ?
										<AsideMenuItem to='/conecta/validacao/email' icon='/media/icons/duotune/menu/conecta/validacao/email.svg' title={'E-mail'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-validacao-telefone-view')) ?
										<AsideMenuItem to='/conecta/validacao/telefone' icon='/media/icons/duotune/menu/conecta/validacao/telefone.svg' title={'Telefone'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-validacao-sellermapping-view')) ?
										<AsideMenuItem to='/conecta/validacao/sellermapping' icon='/media/icons/duotune/menu/conecta/validacao/sellermapping.svg' title={'Seller Mapping'} fontIcon='bi-app-indicator' /> : null}

									{permissions?.some(feature => feature.name.includes('conecta-validacao-cnpjmigrado-view')) ?
										<AsideMenuItem to='/conecta/validacao/cnpjmigrado' icon='/media/icons/duotune/menu/conecta/validacao/cnpjmigrado.svg' title={'CNPJ Migrado'} fontIcon='bi-app-indicator' /> : null}

								</AsideMenuItemWithSub> : null}

						</AsideMenuItemWithSub> : null}

					{menuAccess.datatransfer ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/datatransfer/data-transfer.svg' title={'Data Transfer'} fontIcon='bi-app-indicator'>

							{permissions?.some(feature => feature.name.includes('datatransfer-metas-financeiras')) ?
								<AsideMenuItem to='/datatransfer/metas-financeiras' icon='/media/icons/duotune/menu/datatransfer/meta-financeira.svg' title={'Meta Financeira'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('datatransfer-nao-faturados')) ?
								<AsideMenuItem to='/datatransfer/pedidos-nao-faturados' icon='/media/icons/duotune/menu/datatransfer/nao-faturado.svg' title={'Consultores CA'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('datatransfer-tabelas-descricao')) ?
								<AsideMenuItem to='/datatransfer/tabelas-descricao' icon='/media/icons/duotune/menu/datatransfer/spreadsheet.svg' title={'Descrição das Tabelas'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('datatransfer-time-gap')) ?
								<AsideMenuItem to='/datatransfer/time-gap' icon='/media/icons/duotune/menu/datatransfer/timegap.svg' title={'Prospecção Indústria'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('datatransfer-multipatrocinadores')) ?
								<AsideMenuItem to='/datatransfer/multipatrocinadores' icon='/media/icons/duotune/menu/datatransfer/multipatrocinadores2.svg' title={'Multipatrocinadores'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('datatransfer-seller-group')) ?
								<AsideMenuItem to='/datatransfer/seller-group' icon='/media/icons/duotune/menu/seller-group.svg' title={'Seller Group'} fontIcon='bi-app-indicator' /> : null}

						</AsideMenuItemWithSub> : null}

					{menuAccess.reports ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/reports/reports.svg' title={'Relatórios'} fontIcon='bi-app-indicator'>

							{permissions?.some(feature => feature.name.includes('reports-pedidos')) ?
								<AsideMenuItem to='/reports/pedidos' icon='/media/icons/duotune/menu/reports/pedidos.svg' title={'Pedidos'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-cadastro-lojistas')) ?
								<AsideMenuItem to='/reports/cadastro-lojistas' icon='/media/icons/duotune/menu/reports/cadastro-lojistas.svg' title={'Cadastro Lojistas'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-cadastro-lojista-interno')) ?
								<AsideMenuItem to='/reports/cadastro-lojista-interno' icon='/media/icons/duotune/menu/cadastro-lojista-interno.svg' title={'Cadastro Lojista Interno'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'reports-lojas-quase-fidelizadas') ?
								<AsideMenuItem to='/reports/lojas-quase-fidelizadas' icon='/media/icons/duotune/menu/store.svg' title={'Lojas Quase Fidelizadas'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'reports-lojas-quase-churn') ?
								<AsideMenuItem to='/reports/lojas-quase-churn' icon='/media/icons/duotune/menu/lojas-quase-churn.svg' title={'Lojas quase Churn'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-cadastro-distribuidores')) ?
								<AsideMenuItem to='/reports/cadastro-distribuidores' icon='/media/icons/duotune/menu/reports/cadastro-distribuidores.svg' title={'Cadastro Distribuidores'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-cadastro-vendedores')) ?
								<AsideMenuItem to='/reports/cadastro-vendedores' icon='/media/icons/duotune/menu/reports/cadastro-vendedores.svg' title={'Cadastro Vendedores'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-distribuidor-prioritario')) ?
								<AsideMenuItem to='/reports/distribuidor-prioritario' icon='/media/icons/duotune/menu/reports/distribuidor-prioritario.svg' title={'Distribuidor Prioritário'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-nota-fiscal')) ?
								<AsideMenuItem to='/reports/nota-fiscal' icon='/media/icons/duotune/menu/reports/nota-fiscal.svg' title={'Nota Fiscal'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-ultimo-preco-estoque')) ?
								<AsideMenuItem to='/reports/ultimo-preco-estoque' icon='/media/icons/duotune/menu/reports/ultimo-preco-estoque.svg' title={'Último Preço Estoque'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-promocoes')) ?
								<AsideMenuItem to='/reports/promocoes' icon='/media/icons/duotune/menu/reports/promocoes.svg' title={'Promoções'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-master-interno')) ?
								<AsideMenuItem to='/reports/master-interno' icon='/media/icons/duotune/menu/reports/cadastro-produtos.svg' title={'Master Interno'} fontIcon='bi-app-indicator' /> : null}
							
							{permissions?.some(feature => feature.name.includes('reports-master-produto')) ?
								<AsideMenuItem to='/reports/master-produto' icon='/media/icons/duotune/menu/reports/master-produto.svg' title={'Master de Produto'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name.includes('reports-faixa-cep')) ?
								<AsideMenuItem to='/reports/faixa-cep-lojista' icon='/media/icons/duotune/menu/reports/faixa-cep-lojista.svg' title={'Faixa de CEP - Lojista'} fontIcon='bi-app-indicator' /> : null}

						</AsideMenuItemWithSub> : null}

					{menuAccess.api ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/api-manage-users.svg' title={'API'} fontIcon='bi-app-indicator'>

							{permissions?.some(feature => feature.name === 'api-manage-users') ?
								<AsideMenuItem to='/api/manage-users' icon='/media/icons/duotune/menu/api-users2.svg' title={'Gerenciar Usuários'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'api-manage-services') ?
								<AsideMenuItem to='/api/manage-services' icon='/media/icons/duotune/menu/api-services.svg' title={'Gerenciar Serviços'} fontIcon='bi-app-indicator' /> : null}

						</AsideMenuItemWithSub> : null}

					{menuAccess.infrapay ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/reports/reports.svg' title={'Infrapay'} fontIcon='bi-app-indicator'>

							{permissions?.some(feature => feature.name === 'infrapay-view') ?
								<AsideMenuItem to='/infrapay' icon='/media/icons/duotune/menu/infrapay.svg' title={'Detalhamento'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'infrapay-view') ?
								<AsideMenuItem to='/infrapay-report' icon='/media/icons/duotune/menu/infrapay-report.svg' title={'Extração'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'infrapay-view') ?
								<AsideMenuItem to='/infrapay-historico-vouchers' icon='/media/icons/duotune/menu/infrapay-historico-vouchers.svg' title={'Histórico Vouchers'} fontIcon='bi-app-indicator' /> : null}

						</AsideMenuItemWithSub> : null}



					{menuAccess.devops ? (
						<AsideMenuItemWithSub
							to=''
							icon='/media/icons/duotune/menu/devops-servers.svg'
							title='DevOps'
							fontIcon='bi-app-indicator'
						>
							{permissions?.some(feature => feature.name.includes('devops-dashboard')) ? (
								<AsideMenuItem
									to='/devops/dashboard'
									icon='/media/icons/duotune/menu/devops-dashboard.svg'
									title='Dashboard'
									fontIcon='bi-app-indicator'
								/>
							) : null}

							{permissions?.some(feature => feature.name.includes('devops-tasks')) ? (
								<AsideMenuItem
									to='/devops/tarefas'
									icon='/media/icons/duotune/menu/devops-tasks.svg'
									title='Tarefas'
									fontIcon='bi-app-indicator'
								/>
							) : null}

							{permissions?.some(feature => feature.name.includes('devops-tasks')) ? (
								boards.length > 0 ? (
									<AsideMenuItemWithSub
										to='/devops/quadros'
										icon='/media/icons/duotune/menu/devops-panel.svg'
										title='Quadros'
										fontIcon='bi-app-indicator'
									>
										{boards.map(board => (
											<AsideMenuItem
												key={board.id}
												to={`/devops/quadros?boardId=${board.id}`}
												title={board.name}
												hasBullet={true}
											/>
										))}
									</AsideMenuItemWithSub>
								) : (
									<AsideMenuItem
										to='/devops/quadros'
										icon='/media/icons/duotune/menu/devops-panel.svg'
										title='Quadros'
										fontIcon='bi-app-indicator'
									/>
								)
							) : null}

							{permissions?.some(feature => feature.name.includes('devops-users')) ? (
								<AsideMenuItem
									to='/devops/usuarios'
									icon='/media/icons/duotune/menu/devops-users.svg'
									title='Usuários'
									fontIcon='bi-app-indicator'
								/>
							) : null}

							{permissions?.some(feature => feature.name.includes('devops-sprints')) ? (
								<AsideMenuItem
									to='/devops/sprints'
									icon='/media/icons/duotune/menu/devops-sprints.svg'
									title='Sprints'
									fontIcon='bi-app-indicator'
								/>
							) : null}

							{permissions?.some(feature => feature.name.includes('devops-teams')) ? (
								<AsideMenuItem
									to='/devops/equipes'
									icon='/media/icons/duotune/menu/devops-team.svg'
									title='Equipes'
									fontIcon='bi-app-indicator'
								/>
							) : null}
						</AsideMenuItemWithSub>
					) : null}

					{menuAccess.briefing ?
						<AsideMenuItemWithSub to='' icon='/media/icons/duotune/menu/briefing-promotion.svg' title={'Briefing Promoções'} fontIcon='bi-app-indicator'>

							{permissions?.some(feature => feature.name === 'briefing-promocoes') ?
								<AsideMenuItem to='/briefing-promocoes/promocoes' icon='/media/icons/duotune/menu/briefing-promotion.svg' title={'Promoções'} fontIcon='bi-app-indicator' /> : null}

							{permissions?.some(feature => feature.name === 'briefing-history') ?
								<AsideMenuItem to='/briefing-promocoes/historico' icon='/media/icons/duotune/menu/briefing-history.svg' title={'Histórico'} fontIcon='bi-app-indicator' /> : null}
								
							{permissions?.some(feature => feature.name === 'briefing-agente') ?
								<AsideMenuItem to='/briefing-promocoes/agente' icon='/media/icons/duotune/menu/briefing-agent.svg' title={'Agente Virtual'} fontIcon='bi-app-indicator' /> : null}

              {availableBriefingTopics.length > 0 ? (
                <AsideMenuItemWithSub to='' title='Tópicos' icon='/media/icons/duotune/menu/briefing-topics/briefing-topics.svg'>
                  {availableBriefingTopics.map((topic) => (
                    <AsideMenuItem
                      key={topic.id}
                      to={topic.route}
                      icon={topic.icon}
                      title={topic.title}
                      wrapTitle
                    />
                  ))}
                </AsideMenuItemWithSub>
              ) : null}
							
							

						</AsideMenuItemWithSub> : null}

					{menuAccess.campaigns ? <AsideMenuItem to='/campaigns' icon='/media/icons/duotune/menu/campaign.svg' title={'Simulador de Campanhas'} fontIcon='bi-app-indicator' /> : null}

					{menuAccess.ai ? <AsideMenuItem to='/ai' icon='/media/icons/duotune/menu/robot-ai-svgrepo-com.svg' title={'Compra AI'} fontIcon='bi-app-indicator' /> : null}

					{menuAccess.agentStudio ? <AsideMenuItem to='/agent-studio' icon='/media/icons/duotune/menu/chip-ai.svg' title={'Agent Studio'} fontIcon='bi-app-indicator' /> : null}

          {menuAccess.platformReview ? <AsideMenuItem to='/platform-review' icon='/media/icons/duotune/menu/reports/reports.svg' title='Platform Review' fontIcon='bi-chat-square-text' /> : null}


          {menuAccess.sellerMapping ? <AsideMenuItem to='/seller-mapping' icon='/media/icons/duotune/menu/permissions.svg' title={'Seller Mapping'} fontIcon='bi-app-indicator' /> : null}

          {menuAccess.administrative ? (
            <AsideMenuItemWithSub
              to=''
              icon='/media/icons/duotune/menu/permissions2.svg'
              title='Administrativo'
              fontIcon='bi-app-indicator'
            >
              {permissions?.some(feature => feature.name === 'analytics-view') ? (
                <AsideMenuItem to='/analytics/overview' icon='/media/icons/duotune/menu/reports/reports.svg' title='Analytics' fontIcon='bi-app-indicator' />
              ) : null}
              {permissions?.some(feature => feature.name === 'fechamentos-view') ? (
                <AsideMenuItem to='/fechamentos' icon='/media/icons/duotune/menu/fechamentos.svg' title='Fechamentos' fontIcon='bi-app-indicator' />
              ) : null}
              {permissions?.some(feature => feature.name === 'logs-view') ? (
                <AsideMenuItem to='/logs' icon='/media/icons/duotune/menu/icon-logs.svg' title='Logs' fontIcon='bi-app-indicator' />
              ) : null}
              {(isSuperAdmin() || permissions?.some(feature => feature.name === 'development-features-manage')) ? (
                <AsideMenuItem to='/development-features' icon='/media/icons/duotune/menu/dev-area.svg' title='Área do Desenvolvedor' fontIcon='bi-app-indicator' />
              ) : null}
              {isSuperAdmin() ? (
                <AsideMenuItem to='/permissions' icon='/media/icons/duotune/menu/permissions2.svg' title='Permissões' fontIcon='bi-app-indicator' />
              ) : null}
              {permissions?.some(feature => feature.name.includes('settings-')) ? (
                <AsideMenuItem to='/settings' icon='/media/icons/duotune/menu/settings.svg' title='Configurações' fontIcon='bi-app-indicator' />
              ) : null}
              {permissions?.some(feature => feature.name.includes('users-view')) ? (
                <AsideMenuItem to='/users' icon='/media/icons/duotune/menu/api-users2.svg' title='Usuários' fontIcon='bi-app-indicator' />
              ) : null}
              {permissions?.some(feature => feature.name.includes('nps-view')) ? (
                <AsideMenuItem to='/nps' icon='/media/icons/duotune/menu/reports/reports.svg' title='NPS' fontIcon='bi-app-indicator' />
              ) : null}
            </AsideMenuItemWithSub>
          ) : null}
        </div>
      </div>
    </MenuGroupProvider>
  );
}
